import { appInfo } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1000px] mx-auto">
        <div className="bg-background-50 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
              移动体验
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-2">
              {appInfo.title}
            </h2>
            <p className="text-sm text-foreground-600 mb-1">
              {appInfo.subtitle}
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6 max-w-[500px] mx-auto lg:mx-0">
              {appInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-6">
              {appInfo.features.map((feature, index) => (
                <span
                  key={index}
                  className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap"
                >
                  <i className="ri-check-line text-sm"></i>
                  {feature}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#contact"
                className="w-full sm:w-auto px-8 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line mr-2"></i>了解更多
              </a>
              <a
                href="#contact"
                className="w-full sm:w-auto px-8 py-3 rounded-lg border border-background-300/60 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-colors duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                联系客服
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-48 md:w-56 lg:w-64">
            <div className="aspect-[9/16] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20lifestyle%20content%20app%20interface%20with%20warm%20color%20scheme%2C%20clean%20modern%20UI%20design%2C%20article%20cards%20with%20images%2C%20minimalist%20mobile%20app%20design%2C%20soft%20lighting%2C%20elegant%20Chinese%20typography%2C%20cozy%20reading%20app%20aesthetic&width=512&height=910&seq=app-mockup&orientation=portrait"
                alt="今日看料移动端体验"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}